import React from "react";

const PasswordTooltip = () => (
  <div
    className="w-100 max-w-315px radius-8px bg-teal-pale p-15px text-black fs-13 fw-400"
    style={{
      position: "absolute",
      top: "-130px",
      left: 0,
      right: 0,
      margin: "0 auto",
      zIndex: 10,
      boxShadow: "-4px 4px 20px 0 rgba(0,0,0,0.15)",
      lineHeight: "1.4",
    }}
  >
    Password must: <br />
    <ul style={{ margin: 0, paddingLeft: 20 }}>
      <li>Be at least 10 characters long</li>
      <li>
        Contain at least one uppercase and one lowercase letter, at least one
        number, and at least one special character (!@#$%^&amp;*).
      </li>
    </ul>
    <div
      className="arrow"
      style={{
        position: "absolute",
        bottom: "-15px",
        left: "50%",
        transform: "translateX(-50%)",
        width: 0,
        height: 0,
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        borderTop: "15px solid #f6ffff",
      }}
    />
  </div>
);

export default PasswordTooltip;
